import { styled } from '@linaria/react';
import { semantic, size, space } from '../../theme/tokens';

export const Track = styled.div`
  display: flex;
  gap: ${space['space-100']};
  width: 100px;
`;

export const Segment = styled.span`
  flex: 1;
  height: 4px;
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.surfaceSubtle};

  &[data-active='true'] {
    background: ${semantic.bg.positiveStrong};
  }
`;
